import bodymovin from 'lottie-web';

export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    // lottie loader
    const lottieIdenitifier = 'div[class^="lottie-"]';
    if ($(lottieIdenitifier).length > 0) {
      $(lottieIdenitifier).each(function() {
        const className = $(this).prop('class').substring(7);
        const filename = $('body').data('resources-path') + `/assets/lottie/${className}.json`;
        const $container = $(this);

        bodymovin.loadAnimation({
          container: $container[0],
          path: filename,
          renderer: 'svg',
          loop: true,
          autoplay: true,
        });
      });
    }

    // Close notice banner
    if ($('#close-notice-btn').length > 0) {
      $('#close-notice-btn').on('click', function(e) {
        e.preventDefault();

        const date = new Date();
        date.setTime(date.getTime() + (24 * 60 * 60 * 1000)); // 1 day expiration

        const expires = 'expires=' + date.toUTCString();
        document.cookie = 'notice-closed=true; expires=' + expires + '; path=/';

        $('.notice-banner').slideUp(200);
      })
    }

    function setMobileHeights() {
      // set mobile selector screen height
      const $selectorScreen = $('.global-mobile-navbar .language-selector-screen');

      $selectorScreen.css({
        'margin-bottom': -$selectorScreen.outerHeight() + 'px',
      });
    }

    // GTranslate unpacker
    if ($('#gtranslate_selector').length > 0) {
      $('#gtranslate_selector option').each(function() {
        if ($(this).val() != '') {
          const langVal = $(this).val();
          const langText = $(this).text();

          // Desktop language switcher
          const $selectorItem = $(`<a href="#" class="language-selector-item">${langText}</a>`);
          $selectorItem.data('langcode', langVal);
          $('.language-selector').append($selectorItem);

          $selectorItem.on('click', function(e) {
            e.preventDefault();
            e.stopPropagation();

            const thisLangCode = $(this).data('langcode');

            // set the language
            $('#gtranslate_selector').val(thisLangCode).change();
          });

          // Mobile language switcher
          const $selectorItemMobile = $(`<a href="#" class="language-selector-item">${langText}</a>`);
          $selectorItemMobile.data('langcode', langVal);
          $('.global-mobile-navbar .language-selector-screen').append($selectorItemMobile);

          $selectorItemMobile.on('click', function(e) {
            e.preventDefault();
            e.stopPropagation();

            const thisLangCode = $(this).data('langcode');

            // set the language
            $('#gtranslate_selector').val(thisLangCode).change();
          });
        }
      });

      setMobileHeights();
    }

    // Determine whether the menu submenu should pull left or right depending on its position
    // this is to avoid overspill
    function didSubmenuOverspill($submenu) {
      if (($submenu.offset().left + $submenu.outerWidth()) > ($('.global-navbar .nav-wrap').offset().left + $('.global-navbar .nav-wrap').outerWidth())) {
        return true;
      }

      return false;
    }

    // Calculates how the submenu should pull, called whenever the container is resized
    function calculateSubmenuOverspill() {
      $('.global-navbar .menu-item-has-children').each(function() {
        const $submenu = $(this).find('.sub-menu');

        if ($submenu.length > 0) {
          if (didSubmenuOverspill($submenu)) {
            $submenu.addClass('sub-right');
          } else {
            $submenu.removeClass('sub-right');
          }
        }
      });
    }

    calculateSubmenuOverspill();

    // Mobile nav toggle
    $('.global-navbar .burger-toggle').on('click', function() {
      // set height of mobile wrap
      if ($('header.banner').hasClass('mobile-open')) {
        $('header.banner').removeClass('mobile-open');

        if ($('.global-mobile-navbar').hasClass('navbar-sticky')) {
          $('body').removeClass('overflow-hidden');
          $('.global-navbar').addClass('navbar-sticky-show');
        }
        
        $('.global-mobile-navbar .interaction-contact').removeClass('interaction-open');
        $('.global-mobile-navbar .interaction-home').addClass('interaction-closed');
      } else {
        const heightDifference = $(window).height() - $('.global-mobile-navbar').offset().top;
        $('.global-mobile-navbar').css({ 'min-height': heightDifference + 'px' });

        $('header.banner').addClass('mobile-open');

        if ($('.global-mobile-navbar').hasClass('navbar-sticky')) {
          $('body').addClass('overflow-hidden');
        }

        $('.global-mobile-navbar .interaction-home').removeClass('interaction-closed');
      }
    });

    // Prevent link following on mobile nav top level items
    $('.global-mobile-navbar .navbar-nav>.menu-item.menu-item-has-children').each(function() {
      const $menuItem = $(this);

      // first to second level
      $menuItem.find('> a').on('click', function(e) {
        if ($(this).parent().hasClass('menu-item-has-children')) {
          e.preventDefault();
          e.stopPropagation();

          $('.global-mobile-navbar .interaction-contact').removeClass('interaction-open');

          setTimeout(function() {
            $('.global-mobile-navbar .interaction-home').removeClass('interaction-closed');
          }, 250);

          // move the sub menu up
          const marginTopText = $menuItem.find('> .sub-menu').css('margin-top');

          var marginTop = 0;

          if (marginTopText != '0px') {
            marginTop = parseInt(marginTopText.substr(0, marginTopText.length - 2));
          }

          const targetTop = $('.global-mobile-navbar .navbar-main').offset().top;
          const difference = $menuItem.find('> .sub-menu').offset().top - marginTop - targetTop;
          $menuItem.find('> .sub-menu').css({ 'margin-top': -difference + 'px' });

          // set height of the container
          const $container = $('.global-mobile-navbar .screen-container');
          const containerHeight = $menuItem.find('> .sub-menu').offset().top + $menuItem.find('> .sub-menu').outerHeight() - $container.offset().top;
          $container.css({ 'min-height': containerHeight + 'px' });

          $('.global-mobile-navbar .navbar-nav>.menu-item').addClass('first-level-hidden');
          $menuItem.find('> .sub-menu').addClass('sub-menu-open');
          $('.global-mobile-navbar .link-return').addClass('show-link');

          $('.global-mobile-navbar .link-language-selector').addClass('language-selector-hidden');
        }
      });

      // second to third level
      if ($menuItem.hasClass('menu-item-has-children')) {
        $menuItem.find('.sub-menu .menu-item > a').on('click', function(e) {

          if ($(this).parent().hasClass('menu-item-has-children')) {
            e.stopPropagation();
            e.preventDefault();
  
            const $thirdLevelSubmenu = $(this).siblings('.sub-menu');
            $thirdLevelSubmenu.addClass('third-sub-menu-open');
    
            $menuItem.find('> .sub-menu').addClass('third-level-open');

            $('.global-mobile-navbar .link-return').addClass('on-third-level');
          }
        });
      }
    });

    // Mobile contact us to reveal options
    $('.global-mobile-navbar .nav-contact').on('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      $('.global-mobile-navbar .interaction-home').addClass('interaction-closed');

      setTimeout(function() {
        $('.global-mobile-navbar .interaction-contact').addClass('interaction-open');
      }, 250);
    });
    
    $('.global-mobile-navbar .interaction-item-close').on('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      $('.global-mobile-navbar .interaction-contact').removeClass('interaction-open');

      setTimeout(function() {
        $('.global-mobile-navbar .interaction-home').removeClass('interaction-closed');
      }, 250);
    });

    $('.global-mobile-navbar .link-return').on('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      // Return to second level link
      if ($(this).hasClass('on-third-level')) {
        $('.global-mobile-navbar .third-sub-menu-open').removeClass('third-sub-menu-open');
        $('.global-mobile-navbar .sub-menu.third-level-open').removeClass('third-level-open');
        $(this).removeClass('on-third-level');
      } else {
        // Return to first level link
        $('.global-mobile-navbar .interaction-contact').removeClass('interaction-open');

        setTimeout(function() {
          $('.global-mobile-navbar .interaction-home').removeClass('interaction-closed');
        }, 250);

        $('.global-mobile-navbar .navbar-nav>.menu-item').removeClass('first-level-hidden');

        $('.global-mobile-navbar .navbar-nav>.menu-item').each(function() {
          $(this).find('.sub-menu').removeClass('sub-menu-open');
        });

        $('.global-mobile-navbar .link-return').removeClass('show-link');
        $('.global-mobile-navbar .link-language-selector').removeClass('language-selector-hidden');
        $('.global-mobile-navbar .language-selector-screen').removeClass('language-selector-show');
        
        setTimeout(function() {
          const $container = $('.global-mobile-navbar .screen-container');
          $container.css({ 'min-height': 'auto' });
        }, 400);
      }
    });

    // Click 'Language' in mobile menu
    $('.global-mobile-navbar .link-language-selector').on('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      
      $('.global-mobile-navbar .interaction-contact').removeClass('interaction-open');

      setTimeout(function() {
        $('.global-mobile-navbar .interaction-home').removeClass('interaction-closed');
      }, 250);

      const $selectorScreen = $('.global-mobile-navbar .language-selector-screen');

      $(this).addClass('language-selector-hidden');
      $('.global-mobile-navbar .link-return').addClass('show-link');
      $selectorScreen.addClass('language-selector-show');

      $('.global-mobile-navbar .navbar-nav .menu-item').each(function() {
        $(this).addClass('first-level-hidden');
      });
    });

    // Auto convert WYSIWYG links to a-underline
    if ($('.wysiwyg-wrap').length > 0) {
      $('.wysiwyg-wrap').each(function() {
        if ($(this).find('a').length > 0) {
          $(this).find('a').each(function() {
            $(this).addClass('a-underline');
          });
        }
      });
    }

    // Search dialog
    const $globalSearchBox = $('.global-search-box');

    function runSearchQuery(query) {
      // disable search button & field
      $globalSearchBox.find('.search-btn').prop('disabled', true);
      $globalSearchBox.find('.search-input').prop('disabled', true);

      // clear the results box
      $globalSearchBox.find('.results-wrap > .row > div:not(.result-template),p').remove();

      // set results text
      $globalSearchBox.find('.search-query').html(query);

      // hide suggestions and show results
      $globalSearchBox.find('.search-suggestions').stop().slideUp(200);
      $globalSearchBox.find('.search-results').stop().slideDown(200);

      // make the AJAX call
      $.ajax({
        url: '/wp-json/search-api/v1/get',
        data: {
          query: query,
        },
      }).done(function(response) {
        const response_data = JSON.parse(response);

        if (response_data.length > 0) {
        
          response_data.forEach((item) => {
            const $resultBox = $globalSearchBox.find('.result-template').clone();
            $resultBox.appendTo($globalSearchBox.find('.results-wrap > .row'));
            $resultBox.removeClass('result-template');
            $resultBox.find('.result-item').prop('href', item.permalink);
            $resultBox.find('.item-title').html(item.title);
            $resultBox.find('.item-description').html(item.description);
            $resultBox.find('.result-item').addClass('item-colour-' + item.colour);
          });

        } else {
          const $notFoundBox = $('<p class="pl-4">No results found. Please modify your search criteria and try again.</p>');
          $globalSearchBox.find('.results-wrap > .row').append($notFoundBox);
        }
        
        // enable search button & field
        $globalSearchBox.find('.search-btn').prop('disabled', false);
        $globalSearchBox.find('.search-input').prop('disabled', false);
      });
    }

    // Show hint on input focus
    $globalSearchBox.find('.search-input').on('focus', function() {
      $globalSearchBox.find('.search-hint-wrap').addClass('hint-show');
    });

    // Hide hint on input blur
    $globalSearchBox.find('.search-input').on('blur', function() {
      $globalSearchBox.find('.search-hint-wrap').removeClass('hint-show');
    });

    // Click on search suggestion
    $globalSearchBox.find('.suggestion-link').on('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      const suggestion = $(this).data('suggestion');
      $globalSearchBox.find('.search-input').val(suggestion);

      runSearchQuery(suggestion);
    });

    // Trigger search when 'enter' pressed on input
    $globalSearchBox.find('.search-input').on('keydown', function(e) {
      if (!$(this).prop('disabled')) {
        if (e.keyCode == 13) {
          runSearchQuery($(this).val());
        }
      }
    });

    // Trigger search when button pressed
    $globalSearchBox.find('.search-btn').on('click', function() {
      if (!$(this).prop('disabled')) {
        runSearchQuery($globalSearchBox.find('.search-input').val());
      }
    });

    // Open search box
    $('.nav-search').on('click', function() {
      $globalSearchBox.addClass('search-box-open');
      $('body').addClass('overflow-hidden');
      $('body').addClass('dialog-padder');
    });
    
    $('.nav-search-mobile').on('click', function() {
      $globalSearchBox.addClass('search-box-open');
      $('body').addClass('overflow-hidden');
      $('body').addClass('dialog-padder');
    });

    // Close search box
    $globalSearchBox.find('.btn-close-search').on('click', function() {
      $globalSearchBox.removeClass('search-box-open');
      $('body').removeClass('overflow-hidden');
      $('body').removeClass('dialog-padder');

      // Reset the search box
      setTimeout(function() {
        $globalSearchBox.find('.search-input').val('');
        $globalSearchBox.find('.search-results').hide();
        $globalSearchBox.find('.search-suggestions').show();
        $globalSearchBox.find('.search-hint-wrap').removeClass('hint-show');
      }, 250);
    });
    
    // full width gallery
    if ($('.fw-carousel').length > 0) {
      $('.fw-carousel').each(function() {
        const $this_ = $(this);

        $this_.owlCarousel({
          nav: true,
          navText: ['<i class="icon-arrow-left-navy"></i>', '<i class="icon-arrow-right-navy"></i>'],
          items: 1,
          dots: false,
          loop: true,
        });

        // Set description
        $this_.on('changed.owl.carousel', function() {
          const $activeSlide = $this_.find('.owl-item.active');
          const descriptor = $activeSlide.find('.fw-item-description').html();

          $this_.siblings('.fw-description').find('.description-data').html(descriptor);
        });
      });
    }

    $('.banner-accessibility').on('click', function() {
      $('#__ba_panel button.gw-launchpad-icon-button').trigger('click');
    });

    $('.accessibility-mobile').on('click', function() {
      $('#__ba_panel button.gw-launchpad-icon-button').trigger('click');
    });

    // Make menu sticky when scroll past notice banner (if applicable)
    var lastScrollY = $(window).scrollTop();
    function checkMobileMenuSticky() {
      var hasNoticeBanner = false;
      var noticeBannerHeight = 80;

      if ($('.notice-banner').length > 0) {
        if ($('.notice-banner').is(':visible')) {
          hasNoticeBanner = true;
          noticeBannerHeight = $('.notice-banner').outerHeight();
        }
      }
      
      if ($('.global-navbar').hasClass('navbar-sticky')) {
        var showSticky = false;

        if ($(window).scrollTop() >= noticeBannerHeight + $('.global-navbar').outerHeight() + 60) {
          if ($(window).scrollTop() < lastScrollY) {
            showSticky = true;
          }
        }

        if (showSticky) {
          $('.global-navbar').addClass('navbar-sticky-show');
        } else {
          $('.global-navbar').removeClass('navbar-sticky-show');
        }
      }

      lastScrollY = $(window).scrollTop();

      var makeSticky = false;

      if ($('header.banner').hasClass('mobile-open')) {
        if (hasNoticeBanner) {
          if ($(window).scrollTop() >= noticeBannerHeight) {
            makeSticky = true;
          }
        }

        makeSticky = true;
      } else {
        if ($(window).scrollTop() >= noticeBannerHeight + $('.global-navbar').outerHeight()) {
          makeSticky = true;
        }
      }

      if (makeSticky) {
        $('.global-navbar').addClass('navbar-sticky');
        $('.global-mobile-navbar ').addClass('navbar-sticky');
      } else {
        $('.global-navbar').removeClass('navbar-sticky');
        $('.global-mobile-navbar ').removeClass('navbar-sticky');
      }

      if ($('header.banner').hasClass('mobile-open') && $('.global-mobile-navbar').hasClass('navbar-sticky')) {
        $('body').addClass('overflow-hidden');
      }
    }

    // Add arrow to notice banner content if links
    if ($('.notice-banner .banner-content a').length > 0) {
      $('.notice-banner .banner-content a').each(function() {
        $(this).addClass('a-arrow');
      });
    }

    // Add arrow to all 'a-arrow's
    if ($('.a-arrow').length > 0) {
      $('.a-arrow').each(function() {
        $(this).append('<span class="s-arrow"></span>');
      });
    }

    /**
     * Make some changes to the rendering of the nav menus
     */
    const $firstLevelSubmenus = $('.global-navbar .navbar-main > .navbar-nav > .menu-item.menu-item-has-children > .sub-menu');
    const usingDarkLogo = $('.navbar-logo.navbar-logo-white').hasClass('d-none');

    // add a container to within the submenu
    $firstLevelSubmenus.each(function() {
      const $submenuContainer = $('<div class="container submenu-container initial"></div>');
      $(this).append($submenuContainer);

      const submenuName = $(this).siblings('a').text();
      const $submenuLabel = $(`<div class="second-level-label">${submenuName}</div>`);
      const $submenuReturn = $('<div class="third-level-return"><a href="#"><i class="icon-return-arrow"></i><span class="return-name"></span></a></div>');
      const $submenuDivider = $('<div class="sub-divider"></div>');

      // Put the label in the container
      $submenuContainer.append($submenuLabel);
      $submenuContainer.append($submenuReturn);
      $submenuContainer.append($submenuDivider);

      $submenuReturn.hide();

      // add a second level row - this is shown when a first level is clicked
      const $submenuRow = $('<div class="row second-level-row"></div>');
      $submenuContainer.append($submenuRow);

      // add a third level row - this is a dummy that is filled when needed
      const $thirdLevelRow = $('<div class="row third-level-row">');
      $thirdLevelRow.removeClass('show');
      $submenuContainer.append($thirdLevelRow);

      // put everything within a column
      $(this).find('> .menu-item').each(function() {
        const $submenuColumn = $('<div class="col-12 col-lg-4 col-xl-3 second-level-col"></div>');
        $submenuColumn.append($(this));

        $submenuRow.append($submenuColumn);
        
        // when clicking a second level menu item, we re-create it within the third 
        $(this).find('> a').on('click', function(e) {
          if ($(this).parent().hasClass('menu-item-has-children')) {
            e.stopPropagation();
            e.preventDefault();

            // Clear the third level
            $thirdLevelRow.empty();

            // Put everything in the third level row
            $(this).siblings('.sub-menu').find('.menu-item').each(function() {
              const $thirdLevelColumn = $('<div class="col-12 col-lg-4 col-xl-3 third-level-col"></div>');
              
              const $thirdLevelItemClone = $(this).clone();
              $thirdLevelColumn.append($thirdLevelItemClone);

              $thirdLevelRow.append($thirdLevelColumn);
            });

            $submenuLabel.hide();

            $submenuReturn.find('.return-name').html(submenuName);
            $submenuReturn.show();

            const containerHeight = $submenuContainer.height();

            $submenuRow.addClass('hide');

            setTimeout(() => {
              $thirdLevelRow.addClass('show');
            }, 300);

            $submenuContainer.css({'min-height': containerHeight + 'px'});
          }
        });
      });

      // On third level return button click
      $submenuReturn.find('> a').on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        $thirdLevelRow.removeClass('show');
        $submenuReturn.hide();
        $submenuLabel.show();

        setTimeout(() => {
          $submenuRow.removeClass('hide');
        }, 300);
      });
    });

    // Open sub menus
    $('.global-navbar .navbar-main > .navbar-nav > .menu-item.menu-item-has-children > a').on('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      if (!$(this).parent().hasClass('open')) {

        $(this).siblings('.sub-menu').find('.second-level-label').show();
        $(this).siblings('.sub-menu').find('.third-level-return').hide();
        $(this).siblings('.sub-menu').find('.second-level-row').removeClass('hide');
        $(this).siblings('.sub-menu').find('.third-level-row').removeClass('show');

        // Close all others
        const $openItems = $('.global-navbar .navbar-main > .navbar-nav > .menu-item.menu-item-has-children.open');

        var timeoutValue = 0;

        if ($openItems.length > 0) {
          timeoutValue = 300;

          $('.global-navbar .navbar-main > .navbar-nav > .menu-item.menu-item-has-children.open').each(function() {
            const $this_ = $(this);
            $this_.find('.sub-menu .submenu-container').removeClass('open');

            setTimeout(() => {
              $this_.removeClass('open');
            }, 300);
          });
        }

        setTimeout(() => {
          // Open this one
          $(this).parent().addClass('open');
          $('.global-navbar').addClass('sub-menu-open');
          $('.navbar-logo.navbar-logo-white').addClass('d-none');
          $('.navbar-logo.navbar-logo-navy').removeClass('d-none');

          $('.global-navbar .navbar-main > .navbar-nav > .menu-item.menu-item-has-children > .sub-menu').removeClass('initial');

          const $submenuContainer = $(this).siblings('.sub-menu').find('.submenu-container');
          $submenuContainer.addClass('open');
        }, timeoutValue);

      }
    });

    // Close sub menus
    $(document).on('click', function(e) {
      const $openItem = $('.global-navbar .navbar-main > .navbar-nav > .menu-item.menu-item-has-children.open');

      if ($openItem.length > 0) {
        if (!$.contains($openItem.get()[0], e.target)) {
          $openItem.find('.sub-menu .submenu-container').removeClass('open');

          setTimeout(() => {
            $openItem.removeClass('open');
            $('.global-navbar .navbar-main > .navbar-nav > .menu-item.menu-item-has-children > .sub-menu').addClass('initial');
            $('.global-navbar').removeClass('sub-menu-open');

            if (!usingDarkLogo) {
              $('.navbar-logo.navbar-logo-white').removeClass('d-none');
              $('.navbar-logo.navbar-logo-navy').addClass('d-none');
            }
          }, 300);
        }
      }
    });


    checkMobileMenuSticky();


    $(window).on('scroll', function() {
      checkMobileMenuSticky();
    });

    $(window).on('resize', function() {
      calculateSubmenuOverspill();
      setMobileHeights();
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js